import { useTheme } from "../../../hooks/useTheme";
import { memo } from "react";
import { MembershipPlan, ThemeType } from "@markit/common.types";
import { HorizontalDivider } from "../../Dividers/HorizontalDivider";
import { Icon } from "@iconify/react";
import ReadOnlyRichTextEditor from "../../TextFields/ReadOnlyRichTextEditor";

type MembershipPlanCardDesktopProps = {
  membership: MembershipPlan;
  themeType?: ThemeType;
};

// Part of the display for the membership plan card for Desktop.
// Needed to separate to properly handle the readonly editor for each card.
const MembershipPlanCardDesktop = (props: MembershipPlanCardDesktopProps) => {
  const { membership, themeType } = props;
  const { theme } = useTheme(themeType);

  return (
    <div className="ColumnNormalSelect">
      <div className="ColumnNormalSelect" style={{ paddingInline: 14 }}>
        <div className="AlignedRow" style={{ gap: 4 }}>
          {membership.groupMembers ? (
            <Icon
              icon="ion:people-circle"
              height={16}
              style={{ color: theme.PrimaryText.color }}
            />
          ) : null}
          <span className="sectionTitle" style={theme.PrimaryText}>
            {membership.name}
          </span>
        </div>
        <div className="AlignedRowSelect" style={{ gap: 4, marginTop: 14 }}>
          <span className="bodyMedium" style={theme.PrimaryText}>
            ${membership.price / 100}
          </span>
          {membership.id !== "free" ? (
            <span className="smallBodySubtext">
              / {membership.billingFrequency}
            </span>
          ) : null}
        </div>
        {membership.groupMembers ? (
          <span
            style={{
              ...theme.LabelText,
              fontSize: 12,
              marginTop: 4,
            }}
          >
            Comes with {membership.groupMembers} additional subscriptions
          </span>
        ) : null}
      </div>
      <HorizontalDivider altMargin={14} eventTheme={themeType} />
      <div className="ColumnNormalSelect" style={{ gap: 7, paddingInline: 14 }}>
        <span style={{ ...theme.LabelText, fontSize: 12 }}>Benefits</span>
        <ReadOnlyRichTextEditor
          body={membership.body}
          theme={theme}
          fontSize={12}
          className={"post-content-editor post-content-editor-select"}
        />
      </div>
    </div>
  );
};

export default memo(MembershipPlanCardDesktop);
